import { motion } from "framer-motion";
import React, { useContext } from "react";
import Footer from "../components/Footer/Footer";
import NotFound from "../components/NotFound/NotFound";
import PageTop from "../components/PageTop/PageTop";
import { Context } from "../context";

const NotFoundPage = () => {
  const { debug, lang } = useContext(Context);

  return (
    <>
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4 }}
      >
        <title>Not found</title>
        <PageTop pageTitle="" />
        <NotFound />
        <Footer />
      </motion.main>
    </>
  );
};

export default NotFoundPage;
